import { render, staticRenderFns } from "./articles.vue?vue&type=template&id=b24950e4&scoped=true&"
import script from "./articles.ts?vue&type=script&lang=ts&"
export * from "./articles.ts?vue&type=script&lang=ts&"
import style0 from "./articles.scss?vue&type=style&index=0&id=b24950e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24950e4",
  null
  
)

export default component.exports